import { r } from '@/theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

type SxObject = Exclude<SxProps<Theme>, readonly unknown[]>;

export const overlayScrollbarSx: SxObject = {
  scrollbarColor: (theme) => `${theme.app.colors.border} transparent`,
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: r('pill'),
  },
  '&::-webkit-scrollbar-corner': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: r('pill'),
  },
};
